export const AGENT_ANALYTICS_CHANGEBOARDING = {
	HAS_PAGE_ANALYTICS_CHANGEBOARDING_BEEN_SEEN:
		'agent-analytics-changeboarding:hasPageAnalyticsChangeboardingBeenSeen',
} as const;

export const AgentAnalyticsChangeboardingOnboardingKeys: readonly [
	'agent-analytics-changeboarding:hasPageAnalyticsChangeboardingBeenSeen',
] = [AGENT_ANALYTICS_CHANGEBOARDING.HAS_PAGE_ANALYTICS_CHANGEBOARDING_BEEN_SEEN] as const;
